// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_x-1";
export var movingGradient = "_x-4";
export var movingGradientBlock = "_x-2";
export var skeleton = "_x-0";
export var skeletonText = "_x-3";